import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { API_SERVICE } from '../CommonApi';

// API_SERVICE.get resolves with the axios error instead of rejecting, so rethrow
// here to let react-query report isError for these calls.
const getOrThrow = async (url) => {
  const response = await API_SERVICE.get(url);
  if (response instanceof Error) throw response;
  return response.data;
};

export const useGetSafetyloopImportStatus = (enabled = true) => {
  return useQuery({
    queryKey: ['safetyloop_import_status'],
    queryFn: () => getOrThrow('safetyloop_import/status'),
    enabled,
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};

export const useGetSafetyloopDirectory = (enabled = true) => {
  return useQuery({
    queryKey: ['safetyloop_import_directory'],
    queryFn: () => getOrThrow('safetyloop_import/directory'),
    enabled,
    retry: 1,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};

export const useImportSafetyloopGroups = (companyId) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload) =>
      API_SERVICE.postRequest('safetyloop_import', payload).then((response) => response.data),
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: ['dashboard'] }),
        queryClient.invalidateQueries({ queryKey: ['company_project_list', companyId] }),
        queryClient.invalidateQueries({ queryKey: ['company_project_list_dropdown', companyId] })
      ])
  });
};
